import React from 'react';

export const BookingProgressIndicator = ({ currentStep, steps }) => {
  return (
    <div className="flex items-center justify-center mt-4 gap-2">
      {steps.map((step, index) => {
        const Icon = step.icon;
        const isActive = index === currentStep;
        const isCompleted = index < currentStep;

        return (
          <div key={index} className="flex items-center">
            {/* Step Circle */}
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 ${
                isActive
                  ? 'bg-rose-500 text-white'
                  : isCompleted
                  ? 'bg-green-500 text-white'
                  : 'bg-gray-200 text-gray-400'
              }`}
            >
              <Icon className="w-4 h-4" />
            </div>

            {/* Connecting Line */}
            {index < steps.length - 1 && (
              <div
                className={`w-8 h-0.5 mx-1 ${isCompleted ? 'bg-green-500' : 'bg-gray-200'}`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
